export const textEllipsis = (text: string, isPreview?: boolean) => {
  const length = isPreview ? 15 : 10;

  return text.length <= length ? text : `${text.slice(0, length)}...`;
};
